import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	pagesTabTitle: {
		defaultMessage: 'Pages',
		description: 'Page tab title',
		id: 'hub-home.hub-home.link-picker.pages',
	},
	landingPagesTabTitle: {
		defaultMessage: 'Landing pages',
		description: 'Page tab title',
		id: 'hub-home.hub-home.link-picker.landing-pages',
	},
	articlesTabTitle: {
		defaultMessage: 'Articles',
		description: 'Article tab title',
		id: 'hub-home.hub-home.link-picker.articles',
	},
	portalsTabTitle: {
		defaultMessage: 'Portals',
		description: 'Portal tab title',
		id: 'hub-home.hub-home.link-picker.portals',
	},
	requestFormsTabTitle: {
		defaultMessage: 'Request forms',
		description: 'Request form tab title',
		id: 'hub-home.hub-home.link-picker.request-forms',
	},
});
